import styled from "@emotion/styled";
import Button from "components/Buttons/Button";

const ArticleCTAButton = styled(Button)`
  font-size: 16px;
  line-height: 20px;
  padding: 15px 32px;
`

export default ArticleCTAButton